<div class="pxp-overlay" *ngIf="visible" (click)="onClose()">
  <div class="pxp-popup" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="pxp-header">
      <div class="pxp-header-title">
        <div class="pxp-header-icon">
          <i class="fas fa-file-excel"></i>
        </div>
        <div>
          <h3>Resi per Vettore</h3>
          <p>Scegli l'intervallo di date e i vettori da includere</p>
        </div>
      </div>
      <button type="button" class="pxp-close-btn" (click)="onClose()" [disabled]="isSubmitting" title="Chiudi">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="pxp-body">

      <!-- Errore di validazione o di caricamento -->
      <div class="pxp-error" *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Intervallo di date -->
      <div class="pxp-section-title">
        <i class="fas fa-calendar-alt me-2"></i>Intervallo di date
      </div>
      <div class="pxp-dates">
        <div class="pxp-date-field">
          <label class="form-label">Data da</label>
          <div class="pxp-date-input-wrapper" [class.is-invalid]="isRangeInvalid" (click)="openPicker('dateFrom')">
            <i class="fas fa-calendar-alt pxp-date-icon"></i>
            <input #dateFromInput
                   type="text"
                   class="form-control pxp-date-input"
                   placeholder="gg/mm/aaaa"
                   readonly>
            <button type="button" class="pxp-date-clear" *ngIf="dateFrom"
                    (click)="clearDate('dateFrom'); $event.stopPropagation()"
                    title="Svuota data">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div class="pxp-date-field">
          <label class="form-label">Data a</label>
          <div class="pxp-date-input-wrapper" [class.is-invalid]="isRangeInvalid" (click)="openPicker('dateTo')">
            <i class="fas fa-calendar-alt pxp-date-icon"></i>
            <input #dateToInput
                   type="text"
                   class="form-control pxp-date-input"
                   placeholder="gg/mm/aaaa"
                   readonly>
            <button type="button" class="pxp-date-clear" *ngIf="dateTo"
                    (click)="clearDate('dateTo'); $event.stopPropagation()"
                    title="Svuota data">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Scorciatoie sull'intervallo -->
      <div class="pxp-quick-ranges">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setLastDays(1)">Oggi</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setLastDays(7)">Ultimi 7 giorni</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setLastDays(30)">Ultimi 30 giorni</button>
      </div>
      <p class="pxp-hint pxp-hint--warning" *ngIf="isRangeInvalid">
        <i class="fas fa-circle-info me-1"></i>
        La data di inizio non può essere successiva a quella di fine.
      </p>

      <!-- Vettori -->
      <div class="pxp-section-title">
        <i class="fas fa-truck me-2"></i>Vettori
        <span class="pxp-count" *ngIf="selectedCarriers.length > 0">{{ selectedCarriers.length }}</span>
      </div>
      <app-searchable-select
              [(ngModel)]="selectedCarriers"
              savedSelectionsKey="returns.platform-excel.carriers"
              [options]="carrierOptions"
              [multiple]="true"
              [loading]="isLoadingCarriers"
              [disabled]="isLoadingCarriers"
              allOptionLabel="Tutti i vettori"
              icon="fas fa-truck"
              searchPlaceholder="Cerca vettore..."
              (valueChange)="onCarriersChange()">
      </app-searchable-select>
      <p class="pxp-hint">
        <i class="fas fa-circle-info me-1"></i>
        Puoi selezionare più vettori. Con "Tutti i vettori" il report include tutti i vettori.
        Il bottone arancione nel menu salva la selezione corrente sul browser per riutilizzarla in seguito.
      </p>
    </div>

    <!-- Footer -->
    <div class="pxp-footer">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="onClose()" [disabled]="isSubmitting">
        Annulla
      </button>
      <button type="button" class="btn btn-sm pxp-submit-btn" (click)="onSave()" [disabled]="!canSave">
        <i class="fas me-1" [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>
        {{ isSubmitting ? 'Generazione in corso...' : 'Genera' }}
      </button>
    </div>
  </div>
</div>
